import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import {
    IAddItem,
    ILineItemAdd,
    IOrderDetails,
    IRelatedItems,
} from '../../../../models/order';
import './modal-styles.css';
import { RootState } from '../../../../store';
import { connect } from 'react-redux';

interface IRelatedItemsList {
    order: IOrderDetails;
    item: IAddItem;
    quantity: number;
    handleAddDeleteAccessory: (partNumber: string, quantity: number) => void;
}

const RelatedItemsList = ({
    item,
    quantity,
    handleAddDeleteAccessory,
}: IRelatedItemsList) => {
    const intl = useIntl();
    return (
        <div className="add-item-list-item">
            <div className="add-item-image">
                <img src={item.imageUrl} alt={item.description} />
            </div>
            <div className="add-item-heading">
                <h2>{item.description}</h2>
            </div>
            <div className="add-item-productNumber">
                <p>{item.partNumber}</p>
            </div>
            {quantity >= 1 && (
                <>
                    <div className="add-item-btn">
                        <div
                            className="btn-group container"
                            role="group"
                            style={{
                                marginLeft: '-20px',
                            }}
                        >
                            <>
                                <button
                                    type="button"
                                    className="btn btn-group-sm btn-default"
                                    onClick={() =>
                                        handleAddDeleteAccessory(
                                            item.partNumber,
                                            quantity - 1
                                        )
                                    }
                                >
                                    -
                                </button>
                                <input
                                    type="text"
                                    className="btn btn-group-sm btn-default"
                                    style={{
                                        width: '55px',
                                    }}
                                    value={intl.formatNumber(quantity)}
                                    readOnly={true}
                                />
                                <button
                                    type="button"
                                    className="btn btn-group-sm btn-default"
                                    onClick={() =>
                                        handleAddDeleteAccessory(
                                            item.partNumber,
                                            quantity + 1
                                        )
                                    }
                                >
                                    +
                                </button>
                            </>
                        </div>
                        <button
                            type="button"
                            onClick={() =>
                                handleAddDeleteAccessory(item.partNumber, 0)
                            }
                            className="btn btn-danger btn-sm"
                            style={{ fontSize: '13px' }}
                        >
                            <FormattedMessage
                                id="Cancel"
                                defaultMessage="Cancel"
                            />
                        </button>
                    </div>
                    <div className="col-sm-2" />
                </>
            )}
            <div className="add-item-btn">
                {quantity <= 0 && (
                    <button
                        type="button"
                        onClick={() =>
                            handleAddDeleteAccessory(item.partNumber, 1)
                        }
                        className="btn btn-primary btn-sm"
                    >
                        <FormattedMessage id="Select" defaultMessage="Select" />
                    </button>
                )}
            </div>
        </div>
    );
};
const mapStateToProps = (state: RootState) => {
    return {
        addItemsResponse: state.addItemsResponse
            ? state.addItemsResponse.data!
            : null,
        relatedItems: state.relatedItems ? state.relatedItems.data! : null,
    };
};

const mapDispatchToProps = {};

const relatedItemsListContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RelatedItemsList);

export default relatedItemsListContainer;
